/**
 * Round 18 S4 -- whether this seat can read the per-person preferences.
 *
 * The examiner's token is confined to its own routes, so its seat asked
 * for /v1/me/preferences on every load and was refused 403
 * examiner_boundary, with and without a grant. A surface for such a seat
 * provides `true`; every reader of the record then does not ask.
 */
import { createContext } from "react";

export const PreferencesUnreachable = createContext(false);
